<template>
  <div>
    <aside class="float-bar">
      <a class="float-item" href="tel:075521010347">
        <span class="tip">{{ guest.tipPhone }}</span>
        <img class="ico" src="https://cdn.yun.sooce.cn/6/48879/webp/fba83e6319c088b0878f18fac284955f.webp" :alt="guest.tipCall">
        <span class="label">{{ guest.tipCall }}</span>
      </a>
      <button class="float-item" type="button" @click="openPopup">
        <span class="tip">{{ guest.tipService }}</span>
        <img class="ico" src="https://cdn.yun.sooce.cn/6/48879/webp/23ff41c3abee1d3d7214348ed0500213.webp" :alt="guest.tipSvc">
        <span class="label">{{ guest.tipSvc }}</span>
      </button>
      <button class="float-item" type="button" @click="backTop">
        <img class="ico" src="https://cdn.yun.sooce.cn/5/1589/png/1694397378229c241c3646a97382cfedc3cd8f9b8ec90.png" :alt="guest.tipTop">
        <span class="label">{{ guest.tipTop }}</span>
      </button>
    </aside>
    <div v-if="visible" class="mask" @click.self="closePopup">
      <div class="popup">
        <button class="close" type="button" @click="closePopup">
          <img :src="fileUrl('index/弹窗关闭.png')" alt="close">
        </button>
        <img class="poster" :src="fileUrl('index/弹窗底图.png')" alt="">
        <form class="form" @submit.prevent="submitForm">
          <h3>{{ guest.title }}</h3>
          <p>{{ guest.subtitle }}</p>
          <textarea v-model="form.content" :placeholder="guest.content"></textarea>
          <input v-model="form.contactName" type="text" :placeholder="guest.name">
          <input v-model="form.phone" type="text" :placeholder="guest.phone">
          <input v-model="form.email" type="text" :placeholder="guest.email">
          <input v-model="form.address" type="text" :placeholder="guest.address">
          <button
            class="submit"
            type="submit"
            :class="{ active: canSubmit && !submitting }"
            :disabled="!canSubmit || submitting"
          >{{ submitButtonText }}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/message.css'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'
import { addGuestMessage } from '@/api/guestMessage'

export default {
  name: 'SiteFloat',
  data() {
    return {
      visible: false,
      submitted: false,
      submitting: false,
      form: {
        content: '',
        contactName: '',
        phone: '',
        email: '',
        address: ''
      }
    }
  },
  computed: {
    /** 按当前路由语言取留言文案 */
    guest() {
      const lang = this.$route.meta && this.$route.meta.lang === 'en' ? 'en' : 'zh'
      return getCopy(lang).guest
    },
    /** 必填项（留言内容、电话）是否已填 */
    canSubmit() {
      return !!(this.form.content || '').trim() && !!(this.form.phone || '').trim()
    },
    /** 提交按钮文案 */
    submitButtonText() {
      if (this.submitting) {
        return this.guest.submitting
      }
      if (this.submitted) {
        return this.guest.submitted
      }
      return this.guest.submit
    }
  },
  beforeDestroy() {
    cancelAnimationFrame(this.scrollFrame)
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 打开留言弹窗；再次留言时先清空上次填写内容 */
    openPopup() {
      this.resetGuestForm()
      this.visible = true
    },
    /** 关闭留言弹窗 */
    closePopup() {
      this.visible = false
    },
    /** 清空留言表单，允许再次提交 */
    resetGuestForm() {
      this.form = {
        content: '',
        contactName: '',
        phone: '',
        email: '',
        address: ''
      }
      this.submitted = false
      this.submitting = false
    },
    /** 回到顶部，时长和缓动跟官网 scrollTime=300 一致 */
    backTop() {
      const self = this
      const start = window.pageYOffset || document.documentElement.scrollTop || 0
      const duration = 300
      const startTime = performance.now()
      cancelAnimationFrame(this.scrollFrame)
      const step = function (now) {
        const progress = Math.min((now - startTime) / duration, 1)
        const eased = 0.5 - Math.cos(progress * Math.PI) / 2
        window.scrollTo(0, Math.round(start * (1 - eased)))
        if (progress < 1) {
          self.scrollFrame = requestAnimationFrame(step)
        }
      }
      this.scrollFrame = requestAnimationFrame(step)
    },
    /** 校验留言表单必填项 */
    validateGuestForm() {
      const content = (this.form.content || '').trim()
      const phone = (this.form.phone || '').trim()
      if (!content) {
        Message.warning(this.guest.warnContent)
        return false
      }
      if (!phone) {
        Message.warning(this.guest.warnPhone)
        return false
      }
      return true
    },
    /** 提交留言到官网公开接口（走 axios 封装） */
    submitForm() {
      if (this.submitting || !this.canSubmit) {
        return
      }
      if (!this.validateGuestForm()) {
        return
      }
      const payload = {
        content: this.form.content.trim(),
        contactName: (this.form.contactName || '').trim(),
        phone: this.form.phone.trim(),
        email: (this.form.email || '').trim(),
        address: (this.form.address || '').trim(),
        siteType: 1
      }
      const self = this
      this.submitting = true
      // 调用留言公开接口；拦截器失败时直接返回 { code, msg }，不走 catch
      addGuestMessage(payload)
        .then(function (body) {
          if (body && body.code === 200) {
            self.submitted = true
            Message.success(self.guest.success)
            setTimeout(function () {
              self.closePopup()
              self.resetGuestForm()
            }, 1200)
            return
          }
          Message.error((body && (body.msg || body.message)) || self.guest.fail)
        })
        .finally(function () {
          self.submitting = false
        })
    }
  }
}
</script>

<style scoped>
.float-bar {
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 40;
  transform: translateY(-50%);
}
.float-item {
  position: relative;
  width: 88px;
  height: 88px;
  box-sizing: border-box;
  margin: 0 10px 4px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e5e5e5;
  border: 0;
  border-radius: 5px;
  box-shadow: none;
  color: #333;
  font-size: 12px;
  letter-spacing: 2px;
  text-decoration: none;
  cursor: pointer;
}
.float-item .ico {
  width: 48px;
  height: 40px;
  object-fit: contain;
}
.float-item .label {
  margin-top: 5px;
}
.tip {
  display: none;
  position: absolute;
  top: 0;
  right: calc(100% + 20px);
  width: 223px;
  box-sizing: border-box;
  padding: 16px 22px;
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  white-space: nowrap;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.float-item:hover .tip {
  display: block;
}
.mask {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup {
  position: relative;
  width: 760px;
  max-width: calc(100% - 32px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  display: flex;
  padding: 28px 24px;
  animation: rotateInUpRight 0.8s both;
}
.close {
  position: absolute;
  top: 12px;
  right: 12px;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.close img {
  width: 22px;
  height: 22px;
}
.poster {
  width: 280px;
  height: 320px;
  object-fit: contain;
  background: #e8f4ff;
  border-radius: 12px;
}
.form {
  flex: 1;
  margin-left: 28px;
  padding-top: 12px;
}
.form h3 {
  margin: 0;
  color: #3aa4ea;
  font-size: 28px;
  font-weight: 500;
}
.form p {
  margin: 10px 0 16px;
  color: #666;
}
.form input,
.form textarea {
  width: 100%;
  box-sizing: border-box;
  border: 0;
  background: #f3f7fb;
  margin-bottom: 14px;
  padding: 12px 14px;
  font-size: 14px;
  outline: none;
}
.form textarea {
  height: 88px;
  resize: none;
}
.submit {
  margin-top: 6px;
  border: 0;
  background: #c5d9eb;
  color: #fff;
  border-radius: 22px;
  padding: 8px 36px;
  font-size: 16px;
  cursor: not-allowed;
  transition: background 0.2s;
}
.submit.active {
  background: #3aa4ea;
  cursor: pointer;
}
.submit:disabled:not(.active) {
  opacity: 0.9;
  cursor: not-allowed;
}
@keyframes rotateInUpRight {
  from {
    opacity: 0;
    transform: rotate3d(0, 0, 1, 45deg);
    transform-origin: right bottom;
  }
  to {
    opacity: 1;
    transform: none;
    transform-origin: right bottom;
  }
}
@media (max-width: 800px) {
  .popup { flex-direction: column; }
  .poster { width: 100%; height: 180px; }
  .form { margin-left: 0; }
}
</style>
